export const getImage = (url) => ({ url });
